// pages/+Page.tsx
import { lazy, Suspense } from "react";
import LoadingComponent from "@fableous/ui/components/layout/LoadingComponent";
import AuthenticatedRoute from "@fableous/ui/components/routes/AuthenticatedRoute";
const CreateStory = lazy(() => import("@fableous/ui/containers/stories/CreateStory"));

function Page() {
	return (
		<Suspense fallback={<LoadingComponent />}>
			<AuthenticatedRoute>
				<CreateStory />
			</AuthenticatedRoute>
		</Suspense>
	);
}

export { Page };
